<template>
  <div>
    <section class="content">
      <div class="container-fluid">
        <div class="row clearfix">
          <div class="bg-light-green" style="margin-top:-1% !important;">
            <!-- <br> -->
            <div class="row paddingku">
              <div class="col-md-3 searching">
                <span class="h_page">Data Kabupaten</span>
                <br>
                <br>
              </div>
              <div class="col-md-6"></div>
              <div class="col-md-3 searching">
                <div class="input-group">
                  <span class="input-group-btn">
                    <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data">
                      <i class="material-icons">add</i>
                    </button>
                  </span>
                  <input type="text" class="form-control" placeholder="Cari data" id="caridata">
                </div> <br>
              </div>
            </div>
          </div>

          <div class="col-xs-12 card">
            <!-- ============================================================ MULAI ======================================================================== -->
            <br>
            <div class="table-responsive">
              <table class="table table-bordered" style="width: 100%">
                <thead>
                  <tr class="bg-info">
                    <th class="text-center" style="width: 5%">No.</th>
                    <th class="text-center" style="width: 10%">Kode</th>
                    <th style="width: 35%">Kabupaten</th>
                    <th style="width: 35%">Wilayah</th>
                    <th class="text-center" style="width: 15%">#</th>
                  </tr>
                </thead>
                <tbody>



                  <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                    <td class="text-center">{{index+1}}.</td>
                    <td class="text-center">{{data.kd_dati2}}</td>
                    <td>{{data.nm_dati2}}</td>
                    <td>{{data.nm_propinsi}}</td>
                    <td class="text-center">
                      <button @click="getView(data.nm_propinsi, data.kd_propinsi, data.nm_dati2, data.kd_dati2)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" data-toggle="modal" data-target="#m_edit_data">
                        <i class="material-icons">create</i>
                      </button>
                      &nbsp;
                      <button @click="removeData(data.kd_dati2)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" >
                        <i class="material-icons">clear</i>
                      </button>
                    </td>
                  </tr>


                </tbody>
              </table>
            </div>

            <hr>
                  <div class="text-center">
                      <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>
                      &nbsp;
                      <span style="font-size: 85%; color: #a5a5a5"><b>{{page_first}} - {{page_last}}</b></span>
                      &nbsp;
                      <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

            <!-- ============================================================ MODAL ======================================================================== -->

            <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
              <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content">
                    <div class="modal-header bg-light-blue">
                      <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                    </div>
                    <div class="modal-body">


                      <div class="row clearfix">
                        <div class="col-md-2 form-control-label">
                            <label for="kode">Nama Provinsi</label>
                        </div>
                        <div class="col-md-10">
                          <div class="form-group">
                            <div class="form-line">
                              <autocomplete
                                :url="URL+ 'api/v1/bhumie_provinsi/autocomplete'"
                                :customHeaders="{authorization: 'kikensbatara '+token }"
                                anchor="nm_propinsi"
                                :initValue="nm_propinsi"
                                :classes="{ input: 'form-control'}"
                                label="writer"
                                :onShouldRenderChild="renderChild"
                                :on-select="getAuto">
                              </autocomplete>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row clearfix">
                        <div class="col-md-2 form-control-label">
                          <label for="kode">Kode Kabupaten</label>
                        </div>
                        <div class="col-md-10">
                          <div class="form-group">
                            <div class="form-line">
                              <input
                                v-model="kd_dati2" type="text" id="nilai" class="form-control" placeholder="Ex : Konawe Selatan"
                              >
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row clearfix">
                        <div class="col-md-2 form-control-label">
                          <label for="kode">Nama Kabupaten</label>
                        </div>
                        <div class="col-md-10">
                          <div class="form-group">
                            <div class="form-line">
                              <input
                                v-model="nm_dati2" type="text" id="nilai" class="form-control" placeholder="Ex : Konawe Selatan"
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                      <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                    </div>
                  </div>
                </div>
              </div>
            <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

            
            <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
              <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog"  >
                <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content">
                    <div class="modal-header bg-light-green">
                      <button @click="exit_modal" type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                      <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                    </div>
                    <div class="modal-body">

                      <div class="row clearfix" v-if="edit_data">
                        <div class="col-md-2 form-control-label">
                            <label for="kode">Nama Provinsi</label>
                        </div>
                        <div class="col-md-10">
                          <div class="form-group">
                            <div class="form-line">
                              <autocomplete
                                :url="URL+ 'api/v1/bhumie_provinsi/autocomplete'"
                                :customHeaders="{authorization: 'kikensbatara '+token }"
                                anchor="nm_propinsi"
                                :initValue="nm_propinsi"
                                :classes="{ input: 'form-control'}"
                                label="writer"
                                :onShouldRenderChild="renderChild"
                                :on-select="getAuto">
                              </autocomplete>
                            </div>
                          </div>
                        </div>
                      </div>


                      <div class="row clearfix">
                        <div class="col-md-2 form-control-label">
                          <label for="kode">Nama Kabupaten</label>
                        </div>
                        <div class="col-md-10">
                          <div class="form-group">
                            <div class="form-line">
                              <input v-model="nm_dati2" type="text" id="nilai" class="form-control" placeholder="Ex : Konawe Selatan">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button @click="editData" type="button" class="btn btn-success waves-effect">RUBAH</button>
                      <button @click="exit_modal" type="button" class="btn btn-danger waves-effect" data-dismiss="modal" >KEMBALI</button>
                    </div>
                  </div>
                </div>
              </div>
            <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->



            <!-- ============================================================ MODAL ======================================================================== -->
            <!-- ============================================================ MULAI ======================================================================== -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>

import Autocomplete from 'vue2-autocomplete-js'

const URL_SERVER = URL_APP;
const URL_PROV = URL_APP+'api/v1/bhumie_provinsi/';
const ADD_URL = URL_APP+'api/v1/bhumie_dati2/';


export default {
  name: "monev_kabupaten",
  components: { Autocomplete },
  data() {
    return {
      kd_propinsi: "",
      nm_propinsi: "",
      kd_dati2: "",
      nm_dati2: "",


      edit_data : false,
      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
      token : localStorage.token,
      URL : URL_SERVER

    };
  },

// =============================================================== METHODS =========================================================================
  methods : {
    getData : function(){
      fetch(ADD_URL+'view', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token
        },
        body : JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      }).then(res => res.json())
        .then((data_res) => {
          this.list_data = data_res.data;
          this.page_last = data_res.jml_data
          console.log(this.list_data);
        })
    },

    addData : function(){
      fetch(ADD_URL+'add', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+ localStorage.token,
        },
        body : JSON.stringify({
          kd_propinsi : this.kd_propinsi,
          nm_dati2 : this.nm_dati2,
          kd_dati2 : this.kd_dati2
        })
      }).then((res_data)=>{
        this.alertku("success", "sukses menambah data");
        this.getData();
      });
    },

    editData : function(){
      fetch(ADD_URL+'update', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+localStorage.token
        },
        body : JSON.stringify({
          kd_propinsi : this.kd_propinsi,
          nm_dati2 : this.nm_dati2,
          kd_dati2 : this.kd_dati2
        })
      }).then((res_data)=>{
        this.alertku("success", "sukses mengubah data");
        this.getData();
      })



    },

    removeData : function(id){
      fetch(ADD_URL+"remove", {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token,
        },
        body : JSON.stringify({
          id : id,
        })
      }).then(()=>{
        this.alertku("success", "sukses menghapus data");
        this.getData();
      })
    },

    getView : function(nm_propinsi,kd_propinsi, nm_dati2, kd_dati2){
      this.nm_propinsi = nm_propinsi;
      this.kd_propinsi = kd_propinsi;
      this.nm_dati2 = nm_dati2;
      this.kd_dati2 = kd_dati2;

      this.edit_data = true;
    },




    exit_modal : function(){
      this.edit_data = false;
    },


// ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getData();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getData();
    },

    cari_data: function() {
      this.getData();
    },
// ================== PAGINASI ====================

// ================== AUTOCOMPLETED ====================
    getAuto : function(obj){
      // console.log(obj);
      this.kd_propinsi = obj.kd_propinsi;
      this.nm_propinsi = obj.nm_propinsi;
    },
    renderChild(data) {
        return `
        <span><b>${data.nm_propinsi}</b></span>
        `
    },
// ================== AUTOCOMPLETED ====================

  },
// =============================================================== METHODS =========================================================================

  mounted() {
    this.getData();
    // this.autocompleted();
  },
};
</script>
